<script lang="ts" setup>
withDefaults(
  defineProps<{
    label?: string
    tooltip?: string
    errors?: string[]
    description?: string
  }>(),
  {
    label: '',
    tooltip: '',
    description: '',
    errors: () => []
  }
)
</script>

<template>
  <article class="flex flex-col items-start gap-2.5">
    <CommonBorderTooltip v-bind="{ isDisabled: !tooltip, content: tooltip }">
      <p v-if="label" class="text-white text-sm font-semibold">
        {{ label }}
      </p>
    </CommonBorderTooltip>

    <div class="w-full flex flex-col">
      <slot />
    </div>

    <p
      v-if="errors.length > 0"
      class="first-letter:uppercase text-red-500 text-sm"
    >
      {{ errors[0] }}
    </p>

    <p v-else-if="description" class="text-neutral-100 text-xs">
      {{ description }}
    </p>
  </article>
</template>
